module.exports = __webpack_public_path__ + "img/validate-file-2.05d18274.svg";